import { render, staticRenderFns } from "./Permisos.vue?vue&type=template&id=4245fb89"
import script from "./Permisos.vue?vue&type=script&lang=js"
export * from "./Permisos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports